import React from "react";

const CartItemView = (props) => {
  const {product} = props;

  return (
    <div className={`
      position-relative
      full-width
    `}>

      <div className={"flex gap-10 align-items-center"}>
        <div className="border-radius-xs overflow-hidden" style={{width: "40px"}}>
          <img src={product.image?.preview} alt={product?.name} className="full-width"/>
        </div>
        <div>
          {product.name}
        </div>
      </div>
    </div>
  );
};

export default CartItemView;
